import React from "react";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class DeveloperDetails extends React.Component {
  static contextType = FilterContext;

  constructor(props) {
    super(props);
  }

  state = {
    developerDetails: [],
    filters: "",
  };

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post("api/edge/office/get_developer_details", BodyAsFormData(filters))
      .then((res) => {
        console.log(res);
        this.setState({ developerDetails: res.data[0] }, () => {
          console.log(this.state.developerDetails);
        });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_developer_details",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ developerDetails: res.data[0] });
        });
    }
  }

  render() {
    return (
      <div class="widget widgetDeveloper widgetWithExtraPadding borderRadiusClass p-0">
        <div class="row m-0 logoWithDetailsDesign">
          <div class="col-lg-5 p-0 logoWithDetailsDesignL">
            <img
              alt="Current Coverage Icon"
              src={this.state.developerDetails.image}
              class="imgWidth100"
            />
          </div>
          <div className="col-lg-7 logoWithDetailsDesignR">
            <div className="logoWithDetailsDesignRInner">
              <h6>{this.state.developerDetails.year_founded}</h6>
              <p>Year Founded</p>
            </div>
            <div className="logoWithDetailsDesignRInner">
              <h6>{this.state.developerDetails.headquarters}</h6>
              <p>Headquarters</p>
            </div>
            <div className="logoWithDetailsDesignRInner">
              <h6 title={this.state.developerDetails.website}>
                {this.state.developerDetails.website}
              </h6>
              <p>Website</p>
            </div>
            <div className="logoWithDetailsDesignRInner">
              <h6>Q2 CY’21</h6>
              <p>Latest Investor PPT</p>
            </div>
          </div>
          {/* <div class="col-lg-6 developerDetails">
            <div className="widgetDeveloperDetails">
              <h6>{this.state.developerDetails.year_founded}</h6>
              <p>Year Founded</p>
            </div>
          </div>
          <div class="col-lg-6 developerDetails">
            <div className="widgetDeveloperDetails">
              <h6>{this.state.developerDetails.headquarters}</h6>
              <p>Headquarters</p>
            </div>
          </div>
          <div class="col-lg-6 developerDetails">
            <div className="widgetDeveloperDetails">
              <h6>{this.state.developerDetails.website}</h6>
              <p>Website</p>
            </div>
          </div>
          <div class="col-lg-6 developerDetails">
            <div className="widgetDeveloperDetails">
              <h6>Q2 CY’21</h6>
              <p>Latest Investor PPT</p>
            </div>
          </div> */}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(DeveloperDetails);
